<div class="gpd-full-page gt-full-router" [style.position]="'relative'" style="height: 100% !important;">
    <div class="back-to-top" [class.show]="backtoTopVisible" (click)="scrollToTop()">
        <i class="fa-solid fa-chevron-up"></i>
    </div>
    <app-page-nav-bar [tabs]="headerTabs"></app-page-nav-bar>
    <div class="wiki-body" [class.wiki-manual-body]="path === 'manual'">
        <div *ngIf="canEditWiki() && isMainPage() && path !== 'manual'" class="wiki-actions">
            <app-gpd-button i18n-text="@@createArticle" text="Create New Article"
                routerLink="/wiki/{{path}}/0/edit" icon="add">
            </app-gpd-button>
        </div>
        <div class="router-content" [style.position]="'relative'" style="height: 100%;">
            <router-outlet [ngStyle]="{'display':'none'}"></router-outlet>
        </div>
    </div>
</div>
